/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_ClientInputs */

const en_site_relation_client = /** @type {(inputs: Site_Relation_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client site`)
};

const id_site_relation_client = /** @type {(inputs: Site_Relation_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs klien`)
};

/**
* | output |
* | --- |
* | "Client site" |
*
* @param {Site_Relation_ClientInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_client = /** @type {((inputs?: Site_Relation_ClientInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_ClientInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_client(inputs)
	return en_site_relation_client(inputs)
});